// extracted by mini-css-extract-plugin
export default {"mainOuter":"styles_mainOuter__wErSg","main":"styles_main__WtXk8","inner":"styles_inner__T48fK","close":"styles_close__Z7jWi"};